var generateStyle = function generateStyle(componentTheme) {
  return {
    resultListHeading: {
      display: 'flex',
      justifyContent: 'flex-start'
    },
    resultListInfo: {
      margin: componentTheme.resultListInfoMargin,
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      alignItems: 'center'
    },
    resultListTitle: {
      width: '100%',
      fontSize: componentTheme.resultListTitleFontSize,
      margin: "".concat(componentTheme.resultListTitleMargin, " 0")
    },
    resultListDescription: {
      width: '100%'
    },
    regradeAlert: {
      paddingLeft: componentTheme.regradeAlertPadding,
      paddingRight: componentTheme.regradeAlertPadding
    }
  };
};
export default generateStyle;